import * as React from 'react';
import { useTranslation } from 'react-i18next';
import './PlannerModal.scss';
import { PlannerListDTO } from '../../../types';
import { Button, Modal } from '@iba-team/portal-react-components/dist';
import { initialList } from '../Planner';

export type PlannerModals = {
  setCurrentList: (value: Partial<PlannerListDTO>) => void,
  currentId: number,
  onClose?: () => void,
}


export const AddEmployeeModal = ({setCurrentList, currentId, onClose} : PlannerModals) => {
  const { t } = useTranslation();

  return(
    <Modal className={'plannerModal'} visible={true}
      footer={[
        <Button theme={{variant: 'neutral', color: 'grey'}} onClick={()=> onClose?.()}>
          { t('cancel') }
        </Button>,
        <>
          <Button theme={{variant: 'secondary', color: 'theme'}} onClick={() => {
            onClose?.();
            setCurrentList({...initialList, userIds: [currentId]});
          } } disabled={false} className={'create_btn'}>
            {t('createList')}
          </Button>
        </>
      ]}
      titleText={t('addEmployee')}
      onClose={()=> onClose?.()}>
      {t('addEmployeeModalNewList')}
    </Modal>
  );
};
